export enum ProjectAuthType {
    REQUIRED = 2,
    OPTIONAL = 1,
    NONE = 0
}